import PreSCNFicAPI, { GetPreSCNFICMeetingsResponse, SavePreSCNFicMeetingRequest, SavePreSCNFicMeetingsResponse } from "../../../../../../src/api/preSCNFic";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchPreSCNFicMeetings = createAsyncThunk<
  GetPreSCNFICMeetingsResponse,
  string,
  { rejectValue: string }
>(
  "preSCNFic/fetchMeetings",
  async (case_id, { rejectWithValue }) => {
    try {
      return await PreSCNFicAPI.getMeetings(case_id);
    } catch (error) {
      return rejectWithValue(
        "Failed to fetch Pre SCN FIC meetings"
      );
    }
  }
);


export const savePreSCNFicMeetings = createAsyncThunk<
  SavePreSCNFicMeetingsResponse,
  { case_id: string; payload: SavePreSCNFicMeetingRequest },
  { rejectValue: string }
>(
  "preSCNFic/saveMeetings",
  async ({ case_id, payload }, { rejectWithValue }) => {
    try {
      return await PreSCNFicAPI.saveMeetings(
        case_id,
        payload
      );
    } catch (error) {
      return rejectWithValue(
        "Failed to save Pre SCN FIC meetings"
      );
    }
  }
);
